import React from 'react';

import EmailValidationForm from '@components/forms/emailValidation';

import useEmailPreValidation from './hooks';

function EmailPreValidation({ onValidated }: { onValidated: (email: string) => void }) {
	const { initialValues, onSubmit } = useEmailPreValidation({ onValidated });

	return <EmailValidationForm initialValues={initialValues} onSubmit={onSubmit} />;
}

export default EmailPreValidation;
